<template>
    <v-modal
        v-if="show"
        title="API Log"
        @close="$emit('close')"
        scroll
        size="extra-large">
        <div slot="contents">
            <div class="modal-content">
                <p class="text-center text-muted">
                    {{expandedData.timeAgo}} ({{expandedData.createdTime}} {{expandedData.timeZone}}) - Response dates and times are in UTC
                </p>
            </div>
            <div class="modal-content">
                <h3 class="stack-m">Request</h3>
                <p v-if="!expandedData.request" class="text-center text-muted">{{noData}}</p>
                <pre v-else class="no-margin"><code v-highlight.json>{{formatCode(expandedData.request)}}</code></pre>
            </div>
            <div class="modal-content">
                <h3 class="stack-m">Response</h3>
                <pre class="no-margin"><code v-highlight.json>{{formatCode(expandedData.response)}}</code></pre>
            </div>
        </div>
    </v-modal>
</template>

<script>
    import vModal from '@/components/modal/v-modal';

    export default {
        components: {
            vModal,
        },
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            expandedData: {
                type: Object,
                default: {},
            },
        },
        data() {
            return {
                noData: 'No API data available',
            };
        },
        methods: {
            formatCode(data) {
                try {
                    const parsedData = JSON.parse(data);
                    return JSON.stringify(parsedData, null, 4);
                } catch (error) {
                    return data;
                }
            },
        },
    };
</script>
